import * as React from 'react';

export interface TabContentProps {
    tabName: string;
    defaultActive: boolean;
    children?: any;
}

class TabContent extends React.Component<TabContentProps, any> {
    render() {
        let className = 'tab-pane';
        if (this.props.defaultActive) {
            className += ' active';
        }

        return (
            <div role='tabpanel' className={className} id={this.props.tabName}>
                {this.props.children}
            </div>
        );
    }
}

export default TabContent;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/TabContent.tsx